import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Icon, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/legal/";

const FamilyHeirloomsLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0]);

  const renderAccordionTips = () => {
    return (
      <>       
      <Grid stackable doubling columns="equal" padded='vertically'>
        <Grid.Column stretched>
          <Segment raised className={styles.highlightsItemWhiteBG} >  
            <div style={{width: '100%', height: '100%', display: "inline-block"}}>
              <p className={styles.learnMoreAccordionText} > <br/>
                Keepsakes and family heirlooms may have significance beyond their monetary value.  Following a 
                death, family members often disagree about who should inherit possessions that that have high 
                sentimental value. One option is to compile a list of key heirlooms and other items and list 
                them on a codicil to the will, after the possible recipients have discussed their preferences. 
                <br/><br/>
                Instead of rewriting the entire will, a codicil is a document that allows you to amend specific 
                provisions while leaving the main document in place. This can be done by contacting the older 
                adult's attorney (preferably the one who drafted the original will) and having the older adult 
                convey the changes they wish to make. 
              </p><br/>
            </div>
          </Segment>  
        </Grid.Column>
      </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Tips on Family Heirlooms </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    },
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}FamilyHeirloomsLearnMore1.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(FamilyHeirloomsLearnMore);
